import React from 'react';

import { ReferencedEntry } from 'contentful';
import { BrandingBanner, SalesChannelPromotion } from 'src/api/contentful/contentTypes.shop';
import { BankPersonalizationInfo } from 'src/components/BankPersonalization/UseBankPersonalization';
import { DetailedPromotion } from 'src/components/ProgramPromotion/UseProgramPromotion';
import { getField } from 'src/utils/EntryUtil';
import { isTypeByKey } from 'src/utils/Object';

export const BannerTitle: React.FC<React.AllHTMLAttributes<HTMLHeadingElement> & {
  bannerInfo?: ReferencedEntry<BrandingBanner> | BankPersonalizationInfo;
  currentPromotion?: ReferencedEntry<SalesChannelPromotion> | DetailedPromotion;
  children?: never;
}> = ({ bannerInfo, currentPromotion, ...props }) => {

  let title = isTypeByKey<ReferencedEntry<BrandingBanner>>(bannerInfo, 'sys') ?
    getField(bannerInfo, 'title') :
    bannerInfo && bannerInfo.partnerName;

  if (currentPromotion) {
    title = isTypeByKey<DetailedPromotion>(currentPromotion, 'promotionDescription') ?
      currentPromotion.promotionDescription :
      getField(currentPromotion, 'bannerEyebrow');
  }

  if (!title) return null;
  return <h3 data-test="partner-banner-title" {...props}>{title}</h3>;
};
